import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { CONSTANTS } from '../../../../Constants/Constants';
import { ISaveMultiPDFConfirmationDialogData } from '../../../../models/reports/ISaveMultiPDFConfirmationDialogData';

@Component({
  selector: 'app-save-multi-pdf-confirmation-dialog',
  imports: [MatDialogModule,
            MatButtonModule,
            TranslatePipe,
            MatIconModule],
  templateUrl: './save-multi-pdf-confirmation-dialog.html',
  styleUrl: './save-multi-pdf-confirmation-dialog.scss'
})
export class SaveMultiPdfConfirmationDialog {
  constructor(
  @Inject(MAT_DIALOG_DATA) readonly data:  ISaveMultiPDFConfirmationDialogData ,
  private readonly dialogRef: MatDialogRef<SaveMultiPdfConfirmationDialog>) {}

  readonly constants = CONSTANTS;
  

}
